import { render, staticRenderFns } from "./Tolls.vue?vue&type=template&id=34b8e2b5&scoped=true"
import script from "./Tolls.vue?vue&type=script&lang=js"
export * from "./Tolls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b8e2b5",
  null
  
)

export default component.exports